import { Component } from '@angular/core';
import { SupportButtonService } from '../services/support-button.service';
import { ApplicantMetricsTrackService } from '../../../root/applicant-metrics-track/applicant-metrics-track.service';
import { AuthService } from '../../../root/auth/auth.service';

@Component({
  selector: 'ats-support-button',
  templateUrl: './support-button.component.html',
  styleUrls: ['./support-button.component.css'],
  standalone: false,
})
export class SupportButtonComponent {
  state$ = this.service.state$;

  constructor(
    private service: SupportButtonService,
    private applicantMetricsTrackService: ApplicantMetricsTrackService,
    private authService: AuthService,
  ) {}

  onClick(): void {
    this.service.openSupportLinkInNewTab();
    if (this.authService.isLogged) {
      this.applicantMetricsTrackService.sendApplicantSupportButtonMetric();
    }
  }
}
